/**
 * store post
 */

import { PostState } from "../type";

export default {
    namespaced: true,
    state: (): PostState => ({
        curTab: undefined,
        postList: [],
        ageRestrictionList: [], //post的ageRestriction点开看过的缓存列表
    }),
    mutations: {
        setCurTab(state: PostState, value: string): void {
            state.curTab = value;
        },
        setAgeRestrictionList(state: PostState, value: any): void {
            const { id } = value;
            const index = state.ageRestrictionList.findIndex(
                (item: any) => item.id === id
            );
            if (index > -1) {
                state.ageRestrictionList[index] = value;
            } else {
                state.ageRestrictionList.push(value);
            }
        },
        clearAgeRestrictionList(state: PostState): void {
            state.ageRestrictionList = [];
        },
    },
    actions: {
        setCurTabAct({ commit }: any, value: string): void {
            commit("setCurTab", value);
        },
        updateAgeRestrictionListAct({ commit }: any, value: any): void {
            commit("setAgeRestrictionList", value);
        },
        clearAgeRestriListAct({ commit }: any): void {
            commit("clearAgeRestrictionList");
        },
    },
    getters: {
        getCurTab(state: PostState) {
            return state.curTab;
        },
        getAgeRestrictionList(state: PostState) {
            return state.ageRestrictionList;
        },
    },
};
